import { useMemo } from "react";
import { ENDPOINTS } from "@/constants/api/endpoints";
import { useApiQuery } from "../../hooks/use-api-query";
import { queryKeys } from "../../query-keys";
import { normalizeSearchFilters } from "@/lib/queries/fetch/search-filters";
import type { SearchFiltersApiResponse } from "@/types/search-filters";

/**
 * Aggregated PLP filter options from `/search/filters`.
 *
 * This route replaces the three separate reference calls the drawer used to
 * make. It is still new on the backend, so callers should treat empty groups as
 * "fall back to the /references/* hooks" rather than "no options exist".
 */
export const useSearchFilters = () => {
  const query = useApiQuery<SearchFiltersApiResponse>(
    queryKeys.search.filters,
    ENDPOINTS.ACCOMMODATIONS.SEARCH_FILTERS,
    {},
    {
      staleTime: 30 * 60 * 1000, // 30 minutes — filter options rarely change
      gcTime: 60 * 60 * 1000,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      retry: false,
    }
  );

  const filters = useMemo(
    () => normalizeSearchFilters(query.data?.data ?? null),
    [query.data]
  );

  return { ...query, filters };
};
